import React, { useState } from "react";
import { Modal, Container, Row, Col, Card, Button } from "react-bootstrap";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import Purchasemodal from "../../../components/purchaseplan/purchasemodal";
import { Close } from "@mui/icons-material";

const staticPlans = [
  {
    _id: "60b943dcfa0b321ab8dcd2d1",
    planName: "Basic Plan",
    pricing: {
      monthly: { currency: "PKR", amount: 2000 },
      yearly: { currency: "PKR", amount: 20000 }
    },
    features: {
      monthly: [
        { title: "Add 1 Client Account" },
        { title: "Standard profile badge" },
        { title: "Get +100 connections boost" },
        { title: "Standard listing index" },
        { title: "Access to basic statistics" },
        { title: "Email support (48h response)" }
      ],
      yearly: [
        { title: "Add 2 Client Accounts (Bonus)" },
        { title: "Basic badge + featured tag" },
        { title: "Get +250 connections boost" },
        { title: "Preferred listing index" },
        { title: "Access to enhanced stats history" },
        { title: "Priority email support (24h)" }
      ]
    }
  },
  {
    _id: "60b943dcfa0b321ab8dcd2d2",
    planName: "Professional Plan",
    pricing: {
      monthly: { currency: "PKR", amount: 4500 },
      yearly: { currency: "PKR", amount: 45000 }
    },
    features: {
      monthly: [
        { title: "Add up to 5 Client Accounts" },
        { title: "Premium verified profile badge" },
        { title: "Get +500 connections boost" },
        { title: "Boost profile (2x visibility)" },
        { title: "Access to professional analytics" },
        { title: "Priority support (12h response)" }
      ],
      yearly: [
        { title: "Add up to 8 Client Accounts (Bonus)" },
        { title: "Premium badge + agency tag" },
        { title: "Get +1,000 connections boost" },
        { title: "Supercharge profile (3.5x boost)" },
        { title: "Access to advanced analytics" },
        { title: "Priority live chat support (4h)" }
      ]
    }
  },
  {
    _id: "60b943dcfa0b321ab8dcd2d3",
    planName: "Elite Plan",
    pricing: {
      monthly: { currency: "PKR", amount: 8000 },
      yearly: { currency: "PKR", amount: 80000 }
    },
    features: {
      monthly: [
        { title: "Add Unlimited Client Accounts" },
        { title: "Exclusive VIP profile badge" },
        { title: "Get +2,000 connections boost" },
        { title: "Ultimate profile (5x boost)" },
        { title: "Custom agency dashboard" },
        { title: "24/7 telephone support" }
      ],
      yearly: [
        { title: "Add Unlimited Client Accounts" },
        { title: "Exclusive VIP + partner badge" },
        { title: "Get +5,000 connections boost" },
        { title: "Maximum profile (8x boost)" },
        { title: "Custom dashboard + subdomains" },
        { title: "24/7 phone + account manager" }
      ]
    }
  }
];

export default function CustomPlanModal({ show, onHide }) {
  const [purchase, setPurchase] = useState(false);
  const [planselected, setPlanselected] = useState(null);
  const [billingPeriod, setBillingPeriod] = useState("monthly"); // "monthly" or "yearly"

  return (
    <>
      <Purchasemodal
        purchase={purchase}
        setPurchase={setPurchase}
        planselected={planselected}
        shopid={null}
        getbusinesstype={null}
      />

      <Modal
        show={show && !purchase}
        onHide={onHide}
        size="xl"
        centered
        dialogClassName="custom-plan-modal"
        backdropClassName="plan-backdrop"
      >
        <Modal.Header className="custom-plan-header">
          <div className="text-start w-100">
            <Modal.Title className="fw-bold text-white fs-3">Account Subscription Plans</Modal.Title>
            <p className="text-light mb-0 font_13">Select a plan to unlock additional client accounts and booster features</p>
          </div>
          <Button variant="link" className="close-icon-btn" onClick={onHide}>
            <Close sx={{ color: "white" }} />
          </Button>
        </Modal.Header>
        <Modal.Body className="custom-plan-body p-4 p-md-5">
          <Container>
            {/* Monthly / Yearly Toggle */}
            <div className="d-flex justify-content-center align-items-center mb-5">
              <span
                className={`fw-bold font_14 ${billingPeriod === "monthly" ? "text-primary" : "text-muted"}`}
                style={{ cursor: "pointer", transition: "color 0.2s" }}
                onClick={() => setBillingPeriod("monthly")}
              >
                Monthly
              </span>
              <div
                className="billing-toggle-track mx-3"
                onClick={() => setBillingPeriod(billingPeriod === "monthly" ? "yearly" : "monthly")}
              >
                <div className={`billing-toggle-thumb ${billingPeriod === "yearly" ? "yearly-active" : ""}`} />
              </div>
              <span
                className={`fw-bold font_14 ${billingPeriod === "yearly" ? "text-primary" : "text-muted"}`}
                style={{ cursor: "pointer", transition: "color 0.2s" }}
                onClick={() => setBillingPeriod("yearly")}
              >
                Yearly <span className="badge bg-success font_10 ms-1" style={{ verticalAlign: "middle" }}>Save ~16%</span>
              </span>
            </div>

            <Row className="justify-content-center g-4">
              {staticPlans.map((plan, index) => {
                const isPopular = index === 1;
                const priceInfo = billingPeriod === "monthly" ? plan.pricing.monthly : plan.pricing.yearly;
                const featuresList = billingPeriod === "monthly" ? plan.features.monthly : plan.features.yearly;

                // Calculate original price (Monthly * 12)
                const originalYearlyPrice = plan.pricing.monthly.amount * 12;

                return (
                  <Col key={plan._id} lg={4} md={6} xs={12}>
                    <Card className={`plan-card border h-100 ${isPopular ? "popular-plan" : ""}`}>
                      {isPopular && <div className="popular-badge">Most Popular</div>}
                      <Card.Body className="d-flex flex-column p-4">
                        <div className="mb-4">
                          <h4 className="plan-name fw-bold mb-1">{plan.planName}</h4>
                          <span className="plan-tag text-uppercase fw-semibold font_11">Account Booster Plan</span>
                        </div>

                        <div className="plan-pricing mb-4">
                          <div>
                            <span className="currency fw-bold fs-4">{priceInfo.currency}</span>
                            <span className="price fw-extrabold display-5"> {priceInfo.amount.toLocaleString()}</span>
                            <span className="duration text-muted font_13">/{billingPeriod === "monthly" ? "month" : "year"}</span>
                          </div>

                          {billingPeriod === "yearly" && (
                            <div className="original-price text-muted font_12 mt-1">
                              <span style={{ textDecoration: "line-through" }}>
                                {plan.pricing.monthly.currency} {originalYearlyPrice.toLocaleString()}
                              </span>
                              <span className="text-success fw-bold ms-2">Save ~16%</span>
                            </div>
                          )}
                        </div>

                        <hr className="my-3 opacity-10" />

                        <div className="plan-features mb-4 flex-grow-1">
                          <h6 className="features-title fw-bold font_13 text-muted mb-3">INCLUDED FEATURES:</h6>
                          {featuresList.map((feature, idx) => (
                            <div key={idx} className="feature-item d-flex align-items-start mb-3">
                              <CheckCircleIcon className="feature-check text-primary me-2 mt-1" />
                              <span className="feature-text font_13 text-dark">{feature.title}</span>
                            </div>
                          ))}
                        </div>

                        <Button
                          className="w-100 py-2.5 rounded-pill border-0 plan-btn fw-bold"
                          onClick={() => {
                            // Construct payload object matching purchase flow expectations
                            const selectedPlanDetails = {
                              _id: plan._id,
                              planName: `${plan.planName} (${billingPeriod === "monthly" ? "Monthly" : "Yearly"})`,
                              pricing: {
                                monthly: {
                                  amount: priceInfo.amount,
                                  currency: priceInfo.currency
                                }
                              }
                            };
                            setPlanselected(selectedPlanDetails);
                            setPurchase(true);
                            onHide();
                          }}
                        >
                          Subscribe Now
                        </Button>
                      </Card.Body>
                    </Card>
                  </Col>
                );
              })}
            </Row>
          </Container>
        </Modal.Body>
      </Modal>
    </>
  );
}
